import * as types from "state/entities/teamAnimations/teamAnimationsTypes";
import * as teamAnimationsFolderTypes from "state/entities/teamAnimationsFolders/teamAnimationsFoldersTypes";
import { findPage } from "../helpers";
import { omit, isEmpty, getPath } from "lib/lodash";
import { formatErrors } from "lib/errorHandling";
import { immutableUpdate } from "lib/immutableUpdate";
import {
  getAssetTypeFromQueryParams,
  getStatePropertyFromAnimationType
} from "views/components/Editor/sidebar/tabs/animations/animationUtils";
import { isGif } from "lib/isGif";
import { EDITOR_ANIMATION_SUBTABS_OPTIONS } from "views/components/Editor/sidebar/tabs/animations/animationsTabConstants";

export const initState = {
  animations: {
    pages: {
      /* isFetching: true|false
       * ids:[]
       * didInvalidate: true|false */
    },
    detailedIds: {},
    totalCount: null
  },
  videos: {
    pages: {
      /* isFetching: true|false
       * ids:[]
       * didInvalidate: true|false */
    },
    detailedIds: {},
    totalCount: null
  },
  all: {
    pages: {
      /* isFetching: true|false
       * ids:[]
       * didInvalidate: true|false */
    },
    detailedIds: {},
    totalCount: null
  },
  folders: {
    //  folderId: {
    //    animations: {
    //     pages: {
    //       isFetching: true|false
    //       ids:[]
    //       didInvalidate: true|false
    //     }
    //    },
    //    videos: {
    //     pages: {
    //       isFetching: true|false
    //       ids:[]
    //       didInvalidate: true|false
    //     }
    //    },
    //    all: {
    //     pages: {
    //       isFetching: true|false
    //       ids:[]
    //       didInvalidate: true|false
    //     }
    //   }
    // }
  },
  pageSize: 50,
  errors: null
};

export const handleAllTeamAnimationRequest = ({ action, state }) => {
  const { page } = action.request;

  return {
    ...state,
    all: {
      ...state.all,
      pages: {
        ...state.all.pages,
        [page]: {
          ...state.all.pages[page],
          isFetching: true
        }
      }
    }
  };
};

export const handleTeamAnimationRequest = ({ action, state }) => {
  const { page } = action.request;

  return {
    ...state,
    animations: {
      ...state.animations,
      pages: {
        ...state.animations.pages,
        [page]: {
          ...state.animations.pages[page],
          isFetching: true
        }
      }
    }
  };
};

export const handleTeamVideoRequest = ({ action, state }) => {
  const { page } = action.request;

  return {
    ...state,
    videos: {
      ...state.videos,
      pages: {
        ...state.videos.pages,
        [page]: {
          ...state.videos.pages[page],
          isFetching: true
        }
      }
    }
  };
};

export const handleAllTeamAnimationRequestSuccess = ({ state, action }) => {
  const {
    response: { ids = [] } = {},
    request: { page }
  } = action;

  if (isEmpty(ids) && Number(page) !== 1) {
    return {
      ...state,
      all: {
        pages: omit(state.all.pages, action.request.page)
      }
    };
  }

  const updatedPage = {
    [page]: {
      isFetching: false,
      ids: ids,
      didInvalidate: false
    }
  };

  return {
    ...state,
    all: {
      pages: { ...state.all.pages, ...updatedPage }
    }
  };
};

export const handleTeamAnimationRequestSuccess = ({ state, action }) => {
  const {
    response: { ids = [] } = {},
    request: { page }
  } = action;

  if (isEmpty(ids) && Number(page) !== 1) {
    return {
      ...state,
      animations: {
        pages: omit(state.animations.pages, action.request.page)
      }
    };
  }

  const updatedPage = {
    [page]: {
      isFetching: false,
      ids: ids,
      didInvalidate: false
    }
  };

  return {
    ...state,
    animations: {
      pages: { ...state.animations.pages, ...updatedPage }
    }
  };
};

export const handleTeamVideoRequestSuccess = ({ state, action }) => {
  const {
    response: { ids = [] } = {},
    request: { page }
  } = action;

  if (isEmpty(ids) && Number(page) !== 1) {
    return {
      ...state,
      videos: {
        pages: omit(state.videos.pages, action.request.page)
      }
    };
  }

  const updatedPage = {
    [page]: {
      isFetching: false,
      ids: ids,
      didInvalidate: false
    }
  };

  return {
    ...state,
    videos: {
      pages: { ...state.videos.pages, ...updatedPage }
    }
  };
};

export const handleTeamAnimationDeleteRequestSuccess = ({
  state,
  stateProperty,
  pageIndex,
  mediaId
}) => {
  const updatedIds = state[stateProperty].pages[pageIndex].ids.filter(
    id => id !== mediaId
  );

  const pageUpdated = {
    ...state[stateProperty].pages[pageIndex],
    ids: updatedIds
  };

  return {
    ...state,
    [stateProperty]: {
      ...state[stateProperty],
      pages: {
        ...state[stateProperty].pages,
        [pageIndex]: pageUpdated
      }
    }
  };
};

export const removeFromFolder = (action, state) => {
  const {
    request: {
      extra: { folderId, contentId }
    }
  } = action;
  const stateProperty = getAssetTypeFromQueryParams(window.location);
  const folder = state.folders[folderId][stateProperty];

  const pages = folder.pages;

  const pageId = findPage(folder.pages, contentId);

  // get an array of contentId without the target
  const updatedPageIds = pages[pageId].ids.filter(
    imageId => imageId !== contentId
  );

  const updatedPage = Object.assign({}, pages[pageId], {
    ids: updatedPageIds
  });

  // replace the page in a clone of the current pages
  const updatedPages = Object.assign({}, pages, { [pageId]: updatedPage });

  const folders = Object.assign({}, state.folders, {
    [folderId]: Object.assign({}, folder[folderId], {
      [stateProperty]: Object.assign({}, folder, { pages: updatedPages })
    })
  });

  // replace the pages with the new updated page list in state
  return Object.assign({}, state, { folders });
};

export const handleUploadToTeamFolderRequestSuccess = ({
  state,
  stateProperty,
  urlAssetType,
  mediaId,
  folderId
}) => {
  if (EDITOR_ANIMATION_SUBTABS_OPTIONS.includes(urlAssetType)) {
    if (urlAssetType === stateProperty) {
      const folderAssetPages = getPath(
        state,
        `folders.${folderId}[${stateProperty}].pages`
      );
      const pageIndex = folderAssetPages
        ? Object.keys(folderAssetPages).length
        : 1;
      return immutableUpdate(state, {
        folders: {
          $auto: {
            [folderId]: {
              [stateProperty]: {
                $auto: {
                  pages: {
                    $auto: {
                      [pageIndex]: {
                        $auto: {
                          isFetching: { $set: false },
                          didInvalidate: { $set: true },
                          ids: {
                            $autoArray: {
                              $unshift: [mediaId]
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    return {
      ...state,
      folders: {
        [folderId]: omit(state.folders[folderId], stateProperty)
      }
    };
  }

  // if no urlAsset type then we should attach the mediaId to all folder state
  const allPages = getPath(state.folders[folderId], `all.pages`);
  const allPageNumber = allPages ? Object.keys(allPages).length : 1;

  return immutableUpdate(state, {
    folders: {
      $auto: {
        [folderId]: {
          $auto: {
            all: {
              $auto: {
                pages: {
                  $auto: {
                    [allPageNumber]: {
                      $auto: {
                        isFetching: { $set: false },
                        didInvalidate: { $set: true },
                        ids: {
                          $autoArray: {
                            $unshift: [mediaId]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  });
};

export const handleUploadTeamAnimationRequestSuccess = ({
  state,
  stateProperty,
  urlAssetType,
  pageIndex,
  mediaId
}) => {
  if (EDITOR_ANIMATION_SUBTABS_OPTIONS.includes(urlAssetType)) {
    if (urlAssetType === stateProperty) {
      return immutableUpdate(state, {
        [stateProperty]: {
          $auto: {
            pages: {
              $auto: {
                [pageIndex]: {
                  $auto: {
                    isFetching: { $set: false },
                    didInvalidate: { $set: true },
                    ids: {
                      $autoArray: {
                        $unshift: [mediaId]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    return {
      ...state,
      [stateProperty]: initState[stateProperty]
    };
  }

  // if no urlAsset type then we should attach the mediaId to all folder state
  const allPages = getPath(state, `all.pages`);
  const allPageNumber = allPages ? Object.keys(allPages).length : 1;

  return immutableUpdate(state, {
    all: {
      $auto: {
        pages: {
          $auto: {
            [allPageNumber]: {
              $auto: {
                isFetching: { $set: false },
                didInvalidate: { $set: true },
                ids: {
                  $autoArray: {
                    $unshift: [mediaId]
                  }
                }
              }
            }
          }
        }
      }
    }
  });
};

const teamAnimationsApiReducers = (state = initState, action) => {
  switch (action.type) {
    case types.ALL_TEAM_ANIMATIONS_REQUEST: {
      return handleAllTeamAnimationRequest({ state, action });
    }

    case types.TEAM_ANIMATIONS_REQUEST: {
      return handleTeamAnimationRequest({ state, action });
    }

    case types.TEAM_VIDEOS_REQUEST: {
      return handleTeamVideoRequest({ state, action });
    }

    case types.ALL_TEAM_ANIMATIONS_REQUEST_SUCCESS: {
      return handleAllTeamAnimationRequestSuccess({ state, action });
    }

    case types.TEAM_ANIMATIONS_REQUEST_SUCCESS: {
      return handleTeamAnimationRequestSuccess({ state, action });
    }

    case types.TEAM_VIDEOS_REQUEST_SUCCESS: {
      return handleTeamVideoRequestSuccess({ state, action });
    }

    case types.ADD_TEAM_ANIMATIONS_PLACEHOLDERS: {
      const { mediaPlaceholders, folderId } = action;
      const mediaIds = mediaPlaceholders.map(media => media.mediaId);
      // handle update of state for each mediaPlaceholder being passed in
      // check type for placeholder, then update the corresponding state
      // only return updated state if uploaded assetType is the same as the editor
      const urlAssetType = getAssetTypeFromQueryParams(window.location);
      const mediaAssetTypes = mediaPlaceholders.map(asset => asset.media.type);
      // only one placeholder is passed into the array each time
      const animationType = mediaAssetTypes[0];
      const mediaId = mediaIds[0];
      const assetType = getStatePropertyFromAnimationType(animationType);

      if (folderId) {
        return handleUploadToTeamFolderRequestSuccess({
          state,
          stateProperty: assetType,
          urlAssetType,
          mediaId,
          folderId
        });
      }

      const assetPages = getPath(state, `${assetType}.pages`);
      const assetPageNumber = assetPages ? Object.keys(assetPages).length : 1;

      return handleUploadTeamAnimationRequestSuccess({
        state,
        stateProperty: assetType,
        urlAssetType,
        pageIndex: assetPageNumber,
        mediaId
      });
    }

    case types.TEAM_ANIMATION_DELETE_REQUEST: {
      const { mediaId } = action.request;

      const allPage = findPage(state.all.pages, action.request.mediaId);
      const animationsPage = findPage(
        state.animations.pages,
        action.request.mediaId
      );
      const videosPage = findPage(state.videos.pages, action.request.mediaId);

      if (allPage) {
        return handleTeamAnimationDeleteRequestSuccess({
          state,
          stateProperty: "all",
          pageIndex: allPage,
          mediaId
        });
      }
      if (animationsPage) {
        return handleTeamAnimationDeleteRequestSuccess({
          state,
          stateProperty: "animations",
          pageIndex: animationsPage,
          mediaId
        });
      }
      if (videosPage) {
        return handleTeamAnimationDeleteRequestSuccess({
          state,
          stateProperty: "videos",
          pageIndex: videosPage,
          mediaId
        });
      }
      return state;
    }

    case types.TEAM_ANIMATION_UPLOAD_REQUEST_SUCCESS: {
      const { mediaId } = action.response;
      const { folderId } = action.extra;
      const mediaType = action.response.media.type;
      const assetType = getStatePropertyFromAnimationType(mediaType);
      const urlAssetType = getAssetTypeFromQueryParams(action.queryParams);

      // prevent addition of mediaId into root state when a folderId has been passed
      if (!mediaId || folderId) return state;

      const assetPages = getPath(state, `${assetType}.pages`);
      const assetPageNumber = assetPages ? Object.keys(assetPages).length : 1;

      return handleUploadTeamAnimationRequestSuccess({
        state,
        stateProperty: assetType,
        urlAssetType,
        pageIndex: assetPageNumber,
        mediaId
      });
    }

    case teamAnimationsFolderTypes.UPLOAD_ANIMATION_TO_TEAM_FOLDER_REQUEST_SUCCESS: {
      const {
        body: { folderId, id: mediaId, filename }
      } = action.request;
      const urlAssetType = getAssetTypeFromQueryParams(action.queryParams);
      const assetType = isGif(filename) ? "animations" : "videos";

      if (!mediaId) return state;

      return handleUploadToTeamFolderRequestSuccess({
        state,
        stateProperty: assetType,
        urlAssetType,
        mediaId,
        folderId
      });
    }

    case teamAnimationsFolderTypes.ADD_ANIMATION_TO_TEAM_FOLDER_REQUEST_SUCCESS: {
      const {
        request: {
          body: { contentId: mediaId, folderId }
        }
      } = action;
      // get the current root pages
      const rootPages = state.all.pages;

      // get the id of the page that contains our add target
      const pageId = findPage(rootPages, mediaId);

      // get an array of mediaIds without the target for the root
      const updatedRootPageIds = rootPages[pageId]?.ids?.filter(
        imageId => imageId !== mediaId
      );

      // compile mediaIds into a clone of the page
      const updatedRootPage = Object.assign({}, rootPages[pageId], {
        ids: updatedRootPageIds
      });

      // replace the page in a clone of the current pages
      const updatedRootPages = Object.assign({}, rootPages, {
        [pageId]: updatedRootPage
      });

      // push mediaId into 'folders' state after it has been removed from the 'all' state
      let updatedFolders = state.folders;
      const targetFolder = state.folders[folderId];
      // if folder state is not empty empty, create clone
      // push media id into updatedFolder page ids
      // replace the target folder with the updated folder object
      if (targetFolder && targetFolder.all) {
        const targetFolderAll = targetFolder.all;
        const targetFolderPages = getPath(targetFolderAll, "pages");
        const targetFolderPageId = targetFolderPages
          ? Object.keys(targetFolderPages).length
          : 1;

        updatedFolders = {
          ...state.folders,
          [folderId]: {
            ...targetFolderAll,
            pages: {
              ...targetFolderAll.pages,
              [targetFolderPageId]: {
                ...targetFolderAll.pages[targetFolderPageId],
                ids: [...targetFolderAll.pages[targetFolderPageId].ids, mediaId]
              }
            }
          }
        };
      }

      // replace the pages with the new updated page list in state
      return {
        ...state,
        all: {
          ...state.all,
          pages: updatedRootPages
        },
        folders: updatedFolders
      };
    }

    case teamAnimationsFolderTypes.REMOVE_ANIMATION_FROM_TEAM_FOLDER_REQUEST_SUCCESS: {
      const {
        request: {
          extra: { folderId, contentId }
        }
      } = action;
      if (!state.folders[folderId]) {
        return state;
      }
      const stateProperty = getAssetTypeFromQueryParams(window.location);
      const folder = state.folders[folderId][stateProperty];
      const pages = folder.pages;
      const pageId = findPage(folder.pages, contentId);

      // get an array of contentId without the target
      const updatedPageIds = pages[pageId].ids.filter(
        imageId => imageId !== contentId
      );

      const updatedPage = Object.assign({}, pages[pageId], {
        ids: updatedPageIds
      });

      // replace the page in a clone of the current pages
      const updatedPages = Object.assign({}, pages, { [pageId]: updatedPage });

      const folders = Object.assign({}, state.folders, {
        [folderId]: Object.assign({}, folder[folderId], {
          [stateProperty]: Object.assign({}, folder, { pages: updatedPages })
        })
      });

      // replace the pages with the new updated page list in state
      return Object.assign({}, state, { folders });
    }

    case types.TEAM_ANIMATIONS_IN_FOLDER_REQUEST: {
      const {
        page,
        params: { folderId }
      } = action.request;
      const assetType = getAssetTypeFromQueryParams(action.queryParams);

      return immutableUpdate(state, {
        folders: {
          [folderId]: {
            $auto: {
              [assetType]: {
                $auto: {
                  pages: {
                    $auto: {
                      [page]: {
                        $auto: {
                          $merge: {
                            isFetching: true
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    case types.TEAM_ANIMATIONS_CLEAR: {
      return initState;
    }

    case types.TEAM_ANIMATIONS_IN_FOLDER_REQUEST_SUCCESS: {
      const {
        page,
        params: { folderId }
      } = action.request;
      const assetType = getAssetTypeFromQueryParams(action.queryParams);

      return immutableUpdate(state, {
        folders: {
          [folderId]: {
            $auto: {
              [assetType]: {
                $auto: {
                  pages: {
                    $auto: {
                      [page]: {
                        $merge: {
                          isFetching: false,
                          didInvalidate: false,
                          ids: action.response.ids || []
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      });
    }

    case types.TEAM_ANIMATION_UPLOAD_REQUEST_FAILURE: {
      const mediaPlaceholderId = action.request.body.id;
      const {
        error,
        request: {
          body: { filename }
        }
      } = action;
      const errors = formatErrors(error, true);

      if (
        error.errors[0].path === "duration" &&
        action.request.body.duration > 0
      ) {
        errors[0].value = "Videos must be less than 5 minutes in duration";
      }

      const assetType = getAssetTypeFromQueryParams(window.location);
      const assetPages = getPath(state, `${assetType}.pages`);
      const pageIndex = assetPages ? Object.keys(assetPages).length : 1;
      const placeholderIdIndex =
        state[assetType].pages[pageIndex].ids.indexOf(mediaPlaceholderId);
      return immutableUpdate(state, {
        [assetType]: {
          $auto: {
            pages: {
              $auto: {
                [pageIndex]: {
                  $auto: {
                    isFetching: { $set: false },
                    didInvalidate: { $set: true },
                    ids: {
                      $splice: [[placeholderIdIndex, 1]]
                    }
                  }
                }
              }
            }
          }
        },
        errors: {
          $auto: {
            [filename]: { $set: errors }
          }
        }
      });
    }

    case types.CLEAR_TEAM_ANIMATION_UPLOAD_ERRORS: {
      const { errors } = state;

      if (!errors) return state;

      return omit(state, errors);
    }

    default:
      return state;
  }
};

export default teamAnimationsApiReducers;
